// src/images/RelicVault/index.js
//
// The Collection Store's own chrome. Everything else the store shows - relic
// sprite sheets, guardian art, guild headshots, badge artwork - is served by
// the backend and referenced by URL, so only these two live in the bundle.

export const BRAND = {
  badge: require('./brand/quiklearn-badge.png'),
  vaultPanelTexture: require('./brand/vault-panel-texture.jpg'),
};
